let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("43hsF"), load("kHDuB")]).then(() => parcelRequire('Il8QU'));